import React from 'react';
import {ListGroup} from 'react-bootstrap';
import {HibuTag, HibuTags} from '../search/search-types';
import {TagGroupComponent} from './tagGroupComponent';

type TagListComponentProps = {
    tags: HibuTags;
    handleTagSelected: (tag: HibuTag) => void;
    handleTagDeselected: () => void;
};

export const TagListComponent = React.memo((props: TagListComponentProps) => {
    if (!props || !props.tags) {
        return null;
    }
    return (
        <div id="tags-list">
            <ListGroup>
                {Object.keys(props.tags)
                    .reverse()
                    .map((key) => (
                        <TagGroupComponent
                            key={key}
                            tagTitle={key}
                            values={props.tags[key]}
                            handleTagSelected={props.handleTagSelected}
                            handleTagDeselected={props.handleTagDeselected}
                        />
                    ))}
            </ListGroup>
        </div>
    );
});
